/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, max: NonNullable<unknown> }} Exercise_Personal_Note_CountInputs */

const en_us2_exercise_personal_note_count = /** @type {(inputs: Exercise_Personal_Note_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}/${i?.max}`)
};

const pt_br2_exercise_personal_note_count = /** @type {(inputs: Exercise_Personal_Note_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}/${i?.max}`)
};

const es_419_exercise_personal_note_count = /** @type {(inputs: Exercise_Personal_Note_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}/${i?.max}`)
};

const pt_pt2_exercise_personal_note_count = /** @type {(inputs: Exercise_Personal_Note_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}/${i?.max}`)
};

const fr_fr2_exercise_personal_note_count = /** @type {(inputs: Exercise_Personal_Note_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}/${i?.max}`)
};

const de_de2_exercise_personal_note_count = /** @type {(inputs: Exercise_Personal_Note_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}/${i?.max}`)
};

const it_it2_exercise_personal_note_count = /** @type {(inputs: Exercise_Personal_Note_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}/${i?.max}`)
};

/**
* | output |
* | --- |
* | "{count}/{max}" |
*
* @param {Exercise_Personal_Note_CountInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_note_count = /** @type {((inputs: Exercise_Personal_Note_CountInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Note_CountInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_note_count(inputs)
	if (locale === "es-419") return es_419_exercise_personal_note_count(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_note_count(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_note_count(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_note_count(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_note_count(inputs)
	return en_us2_exercise_personal_note_count(inputs)
});
export { exercise_personal_note_count as "exercise-personal.note_count" }